import { RootState } from "../../app";

const selectConfigMap = (state: RootState) => state.configMapReducer.configMap;

export default selectConfigMap;
